// Хелперы дерева документов сделки (GROUP → DATE → VEHICLE → DOCUMENT). Чистые функции (без React).
import type { DocumentTreeNode } from '@/types/deals';

/** Число листовых документов (узлов DOCUMENT) в поддереве — для счётчиков групп и режима «Документы». */
export function countTreeDocuments(nodes: readonly DocumentTreeNode[]): number {
  return nodes.reduce(
    (sum, node) => sum + (node.nodeType === 'DOCUMENT' ? 1 : countTreeDocuments(node.items ?? [])),
    0,
  );
}
